// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`Funding model belongsTo relations 1`] = `
Array [
  "Project",
  "File",
]
`;
